/**
 * NOTE: alova 关于何时使用 useHook 和 method 发起请求的介绍
 * https://alova.js.org/zh-CN/tutorial/project/best-practice/skills/
 */
import { commonUtils } from '@/helpers/commonUtils'
import { createAlova } from 'alova'
import { xhrRequestAdapter } from '@alova/adapter-xhr'
import { message } from 'antd'
import reactHook from 'alova/react'
import { userService } from '@/services/userService'

const HOST = window.location.origin
const PATH_PREFIX = '/ad_api'

const instance = createAlova({
  baseURL: `${HOST}${PATH_PREFIX}`,
  /** fetch 适用在 app or 小程序 */
  requestAdapter: xhrRequestAdapter(),
  /** 共享请求 */
  shareRequest: true,
  /** 超时 */
  /** 这里先去除超时，因为可能是这里导致请求出现问题 */
  timeout: 0,
  /** 前端缓存时间 https://alova.js.org/zh-CN/tutorial/cache/mode */
  cacheFor: { GET: 1000, POST: 1000 },
  /** 开启可以使用 hook 的配置 */
  statesHook: reactHook,
  beforeRequest: (method) => {
    method.config.headers.accept = 'application/json; charset=UTF-8'
    /** request args */
    method.config.params = commonUtils.underlineObj(method.config.params)
    /** request body */
    const _data = commonUtils.underlineObj(method.data as Record<string, any>)
    method.data = _data
  },
  responded: {
    onSuccess: async (response) => {
      // console.log('response ', response)
      /** http 报错 */
      if (response.status >= 400) {
        message.error(response.statusText)
        Promise.reject(response.statusText)
        throw new Error(response.statusText)
      }
      const responseData = response.data as Record<string, any>
      const camelResponseData = commonUtils.camelizeObj(responseData)
      /** 业务报错 */
      if (camelResponseData.statusCode >= 400) {
        if (camelResponseData.statusCode === 10031 || camelResponseData.statusCode === 10032) {
          userService.userInfo = null
        }
        //   message.error(camelResponseData.statusMessage)
        return Promise.reject(camelResponseData as ApiError)
        // return
      }
      return camelResponseData
    },
    onError: (response) => {
      // console.log('request error', response)
      if (response.status >= 400) {
        message.error(response.statusText)
      }
    },
    onComplete: () => {
      // console.log('resposne', reponse)
      // console.log('request complete', reponse)
      // return { data: null }
    },
  },
})

/** 上传实例 */
const uploadInstace = createAlova({
  timeout: 0,
  requestAdapter: xhrRequestAdapter(),
  beforeRequest: (method) => {
    method.config.withCredentials = false
    if (method.data instanceof Blob || method.data instanceof File) {
      method.config.headers = {
        ...method.config.headers,
        'Content-Type': method.data.type,
      }
    }
    // console.log('method', method)
  },
  /** 开启可以使用 hook 的配置 */
  statesHook: reactHook,
})

export const get = <R = {}>(path: string, params?: Record<string, any>) => {
  return instance.Get<R>(path, { params, withCredentials: true })
}

export const post = <R = {}>(
  path: string,
  params: Record<string, any>,
  body: Record<string, any>
) => {
  return instance.Post<R>(path, body, { params, withCredentials: true })
}

export const putForUpload = <R = {}>(path: string, body: any) => {
  return uploadInstace.Put<R>(path, body, {})
}
export const blobGet = <R = {}>(path: string, params?: Record<string, any>) => {
  return uploadInstace.Get<R>(path, { params, withCredentials: false, responseType: 'blob' })
}

export default instance
